import { ActionFactoryParams } from '../../../../utilsDeprecated/ControlledComponent/ControlledComponent.types';
import { CalendarStateDeprecated } from '../../controller';
import { CalendarContext } from '../../../../utilsDeprecated/context/contextFactory';
import getToastType, { ToastType } from '../../../../utilsDeprecated/state/getToastType';
import { RemoveError } from '../removeError/removeError';
import { CalendarErrors } from '../../../../types/types';

export type OnToastClose = () => void;

export function createOnToastCloseAction(
  { getControllerState }: ActionFactoryParams<CalendarStateDeprecated, CalendarContext>,
  removeError: RemoveError,
): OnToastClose {
  return () => {
    const [state] = getControllerState();
    const toastType = getToastType(state);

    switch (toastType) {
      case ToastType.RescheduleError:
        removeError(CalendarErrors.RESCHEDULE_SERVER_ERROR);
        break;
      case ToastType.AvailableSlotsError:
        removeError(CalendarErrors.AVAILABLE_SLOTS_SERVER_ERROR);
        break;
      case ToastType.NextAvailableSlotError:
        removeError(CalendarErrors.NEXT_AVAILABLE_DATE_SERVER_ERROR);
        break;
      default:
        break;
    }
  };
}
